import {
    Button,
    Label,
    pxToRem,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';
import * as S from './FindNearest.style';
import { MapMarkerHovered } from '@archipro-design/icons';
import { useState } from 'react';
import { FindNearestMobile } from './FindNearest.mobile';

export const FindNearest = ({
    numberOfLocations,
    calculateDistance,
}: {
    numberOfLocations?: number;
    calculateDistance: () => Promise<boolean>;
}) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    const [showChangeSettingText, setShowChangeSettingText] = useState(false);

    if (mobile) {
        return (
            <FindNearestMobile
                calculateDistance={calculateDistance}
                numberOfLocations={numberOfLocations}
                showChangeSettingText={showChangeSettingText}
                setShowChangeSettingText={setShowChangeSettingText}
            />
        );
    }

    return (
        <div className={css(S.FindNearestSection)}>
            <div>
                <Button
                    transparent={true}
                    onClick={async () => {
                        const hasDistance = await calculateDistance();
                        if (!hasDistance) {
                            setShowChangeSettingText(!showChangeSettingText);
                        }
                    }}
                    iconAfter={<MapMarkerHovered />}
                    size={18}
                    text
                    variables={{
                        iconPadding: 0,
                        buttonSize18IconXMargin: pxToRem(8),
                    }}
                >
                    Find Nearest Location
                </Button>
                {showChangeSettingText && (
                    <Label
                        variant="01"
                        weight="regular"
                        className={css(S.FindNearestText)}
                    >
                        Please change your browser settings to allow location
                        services.
                    </Label>
                )}
            </div>
        </div>
    );
};
